import React from 'react';
import useMap from '../../../../hooks/use-map';

export function MapLegendMap() {
    const map = useMap();

    const [mapState, setMapState] = React.useState({
        zoom: 0,
        pitch: 0,
        bearing: 0
    });
    React.useEffect(() => {
        return map?.on('moveend', (e) => {
            setMapState({
                zoom: map.getZoom(),
                pitch: map.getPitch(),
                bearing: map.getBearing()
            });
        }).unsubscribe;
    }, [map]);

    return (
        <div style={{ display: 'grid', gridTemplateColumns: 'max-content auto', columnGap: '0.5rem' }}>
            <div>Zoom:</div>
            <div>{mapState.zoom.toFixed(1)}</div>

            <div>Pitch:</div>
            <div>{mapState.pitch.toFixed(1)} deg</div>

            <div>Bearing:</div>
            <div>{mapState.bearing.toFixed(1)} deg</div>
        </div>
    );
}
